export const pathSection = (pathname: string) => pathname.split('/').filter(Boolean)[0] ?? 'home';

export type NativeShareResult = 'shared' | 'cancelled' | 'unsupported';

type ShareEnv = {
  share?: (data: ShareData) => Promise<void>;
  isTouch: boolean;
};

const browserEnv = (): ShareEnv => ({
  share: typeof navigator !== 'undefined' && navigator.share ? navigator.share.bind(navigator) : undefined,
  isTouch: typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)').matches,
});

// Desktop browsers expose navigator.share too, but there the dialog is richer (embed code), so the sheet is phone-only.
export async function shareNatively(data: ShareData, env: ShareEnv = browserEnv()): Promise<NativeShareResult> {
  if (!env.share || !env.isTouch) return 'unsupported';
  try {
    await env.share(data);
    return 'shared';
  } catch (err) {
    return err instanceof Error && err.name === 'AbortError' ? 'cancelled' : 'unsupported';
  }
}
